import {useParams} from "react-router-dom";

type FacilitySettingsRouteParams = Readonly<{
  facilityId: string;
}>;

export const useFacilitySettingsParams = () =>
  useParams<FacilitySettingsRouteParams>();
